<template>
  <v-layout row wrap>
    <v-flex xs12 sm12 md12>
      <v-toolbar class="primary white--text">
        <v-flex xs12>
          <h2 class=" headline font-weight-light">
            Deleted Invoices
          </h2>
        </v-flex>
        <v-spacer></v-spacer>
        <router-link to="/Dashboard">
          <v-btn icon>
            <v-icon class="white--text">close</v-icon>
          </v-btn>
        </router-link>
      </v-toolbar>

      <!-- firm and Date filter -->
      <v-toolbar class="mb" color="white--text" flat>
        <v-layout row>
          <v-flex>
            <v-autocomplete
              dense 
              flat
              clearable
              item-text="name"
              return-object
              :items="firmsByBrand"
              label="Select Firm"
              v-model="selectedFirm"
            ></v-autocomplete>
          </v-flex>
          <v-spacer/>
          
          <v-flex>
            <v-menu
              :close-on-content-click="false"
              v-model="fromdatepicker"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                clearable
                slot="activator"
                v-model="filterInvoiceFrom"
                single-line
                label="From Date"
                readonly
              ></v-text-field>
              <v-date-picker v-model="filterInvoiceFrom" @input="fromdatepicker = false" />
            </v-menu>
          </v-flex>
            
          <v-flex>
            <v-menu
              :close-on-content-click="false"
              v-model="todatepicker"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
              >
                <v-text-field
                  clearable
                  slot="activator"
                  v-model="filterInvoiceTo"
                  label="To Date"
                  single-line
                  readonly
                ></v-text-field>
                <v-date-picker v-model="filterInvoiceTo" @input="todatepicker = false" />
              </v-menu>
            </v-flex>
          </v-layout>
        </v-toolbar>
      <!-- End of Firm and Date Filter -->  

      <v-layout row wrap>
        <v-flex xs12>
          <v-data-table
            :headers="invoiceHeader"
            :items="getInvoice"
            class="elevation-1 dashboardHead"
          >
            <template slot="items" slot-scope="props">
              <template>
                <td class="primary--text font-weight-bold" v-html="renderDate(props.item.date)"></td>
                <!-- <td>
                  <b>{{ props.item['.key']}}</b>
                </td> -->
                <td>
                  <b>{{ props.item['invoiceId']}}</b>
                </td>
                <td>
                  <b>{{ getCurrentUserName(props.item.buyerId)}}</b>
                </td>
                <td>
                  <b class="success--text">{{Number.parseFloat(props.item.totalAmount)|| 0 | amount }}</b>
                </td>
                 <td>
                  <b>{{ props.item.status}}</b>
                </td>
                <!-- <td>
                  <b>{{ props.item.paymentType}}</b>
                </td>  -->
                <td>
                  <b><v-btn color="primary" @click="restoreInvoice(props.item)">RESTORE</v-btn></b>
                </td>
                <td>
                  <b><v-btn color="warning" @click="deleteInvoice(props.item)">DELETE</v-btn></b>
                </td>                    
                <td>
                  <b>{{getFirmName(props.item.firm)}}</b>
                </td>                    
              </template>
            </template>
            <template slot="no-data">No Items</template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
export default {
  data() {
    return {
      invoiceHeader: [
        { text: "Date", value: "date", sortable: true },
        // { text: "Invoice Key", value: "key" },
        { text: "Invoice ID", value: "invoiceId" },
        { text: "Customer Name", value: "name" },
        { text: "TotalAmount", value: "TotalAmount" },
        { text: "Status", value: "status" },
        { text: "Restore", value: "restore" },
        { text: "Delete", value: "delete" },
        { text: "Firm", value: "firmName" },
      ],
      selectedFirm: null,
      filterInvoiceFrom: null,
      filterInvoiceTo: null,
      fromdatepicker: false,
      todatepicker: false,
    };
  },
  created() {
    this.$bindAsObject("firm", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray("account", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsObject("buyerById", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsObject("sellerById", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray('invoices', this.$root.$firebaseRefs.invoice.orderByChild('brandFinYear').equalTo(this.brandFinYear))
    this.$bindAsArray('invoiceHistories', this.$root.$firebaseRefs.invoiceHistory).orderByChild('brandFinYear').equalTo(this.brandFinYear)
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "finYear","brandFinYear"]),
    firmsByBrand1() {
      return this.firms
      .filter(item => item["brand"] === this.selectedBrand)
    },
    // current brands firm list
    firmsByBrand () {
      // return selected brand firms
      let firmsB = this.firms
        .filter((item) => item['brand'] === this.selectedBrand)
        firmsB.map((item) => {
          if (item.defaultFirm) {
            this.selectedFirm = item;
          }
        })
      return firmsB;
    },
    getInvoice() {
      let toDate = this.toDate ?  new Date(this.toDate).getTime() : null;
      let fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;  
      let invoices = this.invoices.filter(item => {
        // return ((this.selectedFirm ? item['firm'] === this.selectedFirm['.key'] : true) &&
        return ((item["brand"] === this.selectedBrand) && (this.selectedFirm ? item['firm'] === this.selectedFirm['.key'] : true) &&
            (fromDate ? item.date >= fromDate : true) &&
            (toDate ? item.date <= toDate : true) &&
            (item.date >= this.finYear.start) && (item.date <= this.finYear.end)&& 
            (item.deleted == true)
        )
      });
      return invoices 
    },
  },
  methods: {
    dayDiff(dt1, dt2) {
        return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate()) ) /(1000 * 60 * 60 * 24));
    },
    restoreInvoice(selectedInvoice){
        if(confirm('Are you sure you want to restore this invoice?')) {
         this.$root.$firebaseRefs.invoice.child(selectedInvoice['.key']).update({
          deleted: false
          }, () => {
            console.info('Invoice Restored...')
        })

        let invoiceHistory = this.invoiceHistories.filter(item =>
          item['brand'] == this.selectedBrand &&
          item['parentInvoiceKey'] == selectedInvoice['.key']
          )
        invoiceHistory.map((invoice)=>{
          this.$root.$firebaseRefs.invoiceHistory.child(invoice['.key']).update({
          deleted: false
            }, () => {
              console.info('Invoice History Restored...')
              this.managePayments(selectedInvoice,false)
          })
        })
      }
    },
    deleteInvoice(selectedInvoice){
       if(confirm('Are you sure you want to delete this invoice?')) {
         if(selectedInvoice.isBuyer) {
          let firmInvoiceCount = this.invoices.filter(
          (item) =>
              item["brand"] === this.selectedBrand &&
              item["firm"] == selectedInvoice.firm &&
              item["isBuyer"] == true
          ).length;
          this.$root.$firebaseRefs.firm.child(selectedInvoice.firm).update({
            lastInvoiceCount: firmInvoiceCount
          }, () => {
            console.info('last invoice Count updated...')
          })
         }
          let invoiceHistory = this.invoiceHistories.filter(item =>
            item['brand'] == this.selectedBrand &&
            item['parentInvoiceKey'] == selectedInvoice['.key']
            )
          invoiceHistory.map((invoice)=>{
            this.$root.$firebaseRefs.invoiceHistory.child(invoice['.key']).remove();
          })
        this.$root.$firebaseRefs.invoice.child(selectedInvoice['.key']).remove();
        this.managePayments(selectedInvoice,true)
      }
    },
    getCurrentUserName(buyerId) {
      let buyer = this.buyerById[buyerId];
      let seller = this.sellerById[buyerId];
      let currentUser =
        buyer && buyer.state ? buyer : seller && seller.state ? seller : {};
      return currentUser.name;
    },
    // getFirmName1(firmId) {
    //   if (this.firm && this.firm[firmId]) {
    //     return this.firm[firmId]["name"];
    //   }
    //   return "--";
    // },
    getFirmName(e) {
      let firm;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(item => item[".key"] === e)[0];
      }
      if (firm) return firm.name;
    },
    renderDate(timeStamp) {
      if (timeStamp) {
        return new Date(timeStamp).toLocaleDateString("en-GB");
      }
      return "--";
    },
     managePayments(invoiceData,isDelete){
      let isAddition = invoiceData.isBuyer;
      isAddition = isDelete ? !isAddition : isAddition;
       switch(invoiceData.paymentType) {
          case 'Cash' : {
            if(invoiceData.amountFromCash) {
              let firm = this.firms.filter(item => item['.key'] == invoiceData.firm)[0]
              if(firm && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                firm.amount = isAddition ? (Number.parseFloat(firm.amount) + Number.parseFloat(invoiceData.amountFromCash)) : (Number.parseFloat(firm.amount) - Number.parseFloat(invoiceData.amountFromCash));   
                delete firm['.key']
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
              }
            }
            break;
          }
          case 'Bank Account' : {
            if(invoiceData.amountFromBank) {
              let bank =  this.banks.filter(item => item['.key'] == invoiceData.bank)[0]
              if(bank && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                bank.amount = isAddition ? (Number.parseFloat(bank.amount) + Number.parseFloat(invoiceData.amountFromBank)) : (Number.parseFloat(bank.amount) - Number.parseFloat(invoiceData.amountFromBank)) ;  
                delete bank['.key']
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(bank);
              }
            }
            break;
          }
          case 'CashAndBank Account' : {
            if(invoiceData.amountFromCash && invoiceData.amountFromBank) {
              let bank = this.banks.filter(item => item['.key'] == invoiceData.bank)[0]
              if(bank && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                bank.amount = isAddition ? Number.parseFloat(bank.amount) + Number.parseFloat(invoiceData.amountFromBank) : Number.parseFloat(bank.amount) - Number.parseFloat(invoiceData.amountFromBank);  
                delete bank['.key']
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(bank);
              }
              let firm = this.firms.filter(item => item['.key'] == invoiceData.firm)[0]
              if(firm && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                firm.amount = isAddition ? Number.parseFloat(firm.amount) + Number.parseFloat(invoiceData.amountFromCash) : Number.parseFloat(firm.amount) - Number.parseFloat(invoiceData.amountFromCash);
                delete firm['.key']
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
              }         
            }
            break;
          }
        }
    },
    
  },
  watch: {}
};
</script>

<style >
.theme--light div.select-firm .v-icon {
  color: white;
}
.theme--light div.select-firm .v-label {
  color: white;
}
.theme--light div.select-firm .v-input__slot:before {
  border-color: white !important;
}
div.select-firm .v-select__selection--comma {
  color: white;
}

.disabledCard {
  background: lightgray;
}

.ist-datepicker .v-icon,
.ist-datepicker .v-label,
.ist-datepicker input {
  color: white !important;
}

.ist-datepicker .v-input__slot:before {
  border-color: white !important;
}

.fl2-table {
  border-radius: 5px;
  font-size: 12px;
  font-weight: normal;
  border: none;
  border-collapse: collapse;
  width: 100%;
  max-width: 100%;
  white-space: nowrap;
  background-color: white;
}

.fl2-table td,
.fl2-table th {
  text-align: center;
  padding: 8px;
}

.fl2-table td {
  border: 1px solid #000000;
  font-size: 12px;
}

.fl2-table thead th {
  color: #ffffff;
  background: #15155d;
  border: 1px solid white;
}

.fl2-table tr:nth-child(even) {
  background: #f8f8f8;
}
</style>



// WEBPACK FOOTER //
// src/components/Informations/DeletedInvoices/DeletedInvoice.vue